import axiosClient from "api/axiosClient";

// base is get, path is patch
export default function createMaintenanceService(baseUrl, pathUrl) {
    return {
        search(params, config = {}) {
            return axiosClient.get(baseUrl, { ...config, params });
        },

        get(id) {
            return axiosClient.get(`${baseUrl}/${id}`);
        },

        create(data) {
            return axiosClient.post(baseUrl, data);
        },

        update(id, data) {
            return axiosClient.put(`${pathUrl || baseUrl}/${id}`, data);
        },

        delete(id) {
            return axiosClient.delete(`${baseUrl}/${id}`);
        }
    };
}
